<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoCrud :titulo="titulo" :accion="accion" @ejecutarAccion="ejecutarAccion" />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <SelectTipoIva :model="itemActivo.Id_TipoIva" :rules="[rules.requerido]" :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.Id_TipoIva = item.Id_TipoIva)
                      " />
                </v-flex>
                <v-flex xs12 md3>
                  <Cuit :model="itemActivo.Cuit" :rules="[rules.requerido]" :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.Cuit = item.Cuit)" />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field label="Nombre de Fantasía*" v-model="itemActivo.Nombre"
                    :rules="[rules.requerido, rules.maximo100]" :readonly="controlSoloLectura"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field label="Razón Social*" v-model="itemActivo.RazonSocial"
                    :rules="[rules.requerido, rules.maximo100]" :readonly="controlSoloLectura"
                    @focus="sugerirRazonSocial"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <SelectTipoIb :model="itemActivo.Id_TipoIb" :rules="[rules.requerido]" :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.Id_TipoIb = item.Id_TipoIb)
                      " />
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field label="IIBB" v-model="itemActivo.Ib" v-mask="'#########'" :rules="[rules.maximo15]"
                    :readonly="controlSoloLectura"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <SelectTipoIg :model="itemActivo.Id_TipoIg" :rules="[rules.requerido]" :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.Id_TipoIg = item.Id_TipoIg)
                      " />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-text-field label="Dirección*" v-model="itemActivo.Direccion" hint="Calle y número" persistent-hint
                    :rules="[rules.requerido, rules.maximo50]" :readonly="controlSoloLectura"></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field label="CPA" v-model="itemActivo.Cp" hint="Ej: C1000WAC" persistent-hint
                    :rules="[rules.maximo15]" :readonly="controlSoloLectura"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <SelectLocalidad :model="itemActivo.Id_Localidad" :rules="[rules.requerido]"
                    :readonly="controlSoloLectura" @seleccionarItem="item => (itemActivo.Id_Localidad = item.Id_Localidad)
                      " />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <v-text-field label="Teléfono Fijo" v-model="itemActivo.Telefono" hint="Prefijo (con 0) y número"
                    persistent-hint :rules="[rules.maximo50]" :readonly="controlSoloLectura"></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field label="Celular" v-model="itemActivo.Celular" hint="Prefijo (Sin 0) y número (Sin 15)"
                    persistent-hint :rules="[rules.maximo50]" :readonly="controlSoloLectura"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field label="E-mail" v-model="itemActivo.Email" :rules="[rules.maximo50, rules.email]"
                    :readonly="controlSoloLectura"></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <Fecha label="Nacimiento" :fecha="itemActivo.FechaNacimiento" :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.FechaNacimiento = item.Fecha)
                      " />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <SelectTipoVenta :model="itemActivo.Id_TipoVenta" :readonly="controlSoloLectura" @seleccionarItem="item => (itemActivo.Id_TipoVenta = item.Id_TipoVenta)
                    " />
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field label="Percepción IIBB" v-model="itemActivo.AlicuotaPercepcionIb"
                    :readonly="controlSoloLectura" hint="Sólo a Distribuidores" persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <SelectTipoPagoCheque :model="itemActivo.Id_TipoPagoCheque" :readonly="controlSoloLectura"
                    @seleccionarItem="item =>
                        (itemActivo.Id_TipoPagoCheque = item.Id_TipoPagoCheque)
                      " />
                </v-flex>
                <v-flex xs12 md2>
                  <Importe label="Límite Crédito" :model="itemActivo.Limite" :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.Limite = item.Importe)
                      " />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-textarea label="Nota" v-model="itemActivo.Nota" :rules="[rules.maximo500]"
                    hint="Otros datos importantes" persistent-hint :readonly="controlSoloLectura" auto-grow
                    rows="2"></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <GrillaCrud :activo="grillaActivo" :columnas="grillaColumnas" :itemsDB="grillaItems" :loading="loading"
      @ejecutarAccion="grillaEjecutarAccion" @editarItem="grillaEditarItem" @borrarItem="grillaBorrarItem" />
    <Mensaje :activo="mensajeActivo" :tipo="mensajeTipo" :titulo="mensajeTitulo" :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion" />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoCrud from "@/components/EncabezadoCrud";
import PieCrud from "@/components/PieCrud";
import GrillaCrud from "@/components/GrillaCrud";
import Mensaje from "@/components/Mensaje";
import Fecha from "@/components/Fecha";
import Cuit from "@/components/Cuit";
import Importe from "@/components/Importe";
import SelectLocalidad from "@/components/Sistema/SelectLocalidad";
import SelectTipoIva from "@/components/Sistema/SelectTipoIva";
import SelectTipoIb from "@/components/Venta/SelectTipoIb";
import SelectTipoIg from "@/components/Venta/SelectTipoIg";
import SelectTipoVenta from "@/components/Venta/SelectTipoVenta";
import SelectTipoPagoCheque from "@/components/Venta/SelectTipoPagoCheque";
export default {
  name: "ClienteCrud",
  components: {
    EncabezadoCrud,
    PieCrud,
    GrillaCrud,
    Mensaje,
    Fecha,
    Cuit,
    Importe,
    SelectLocalidad,
    SelectTipoIva,
    SelectTipoIb,
    SelectTipoIg,
    SelectTipoVenta,
    SelectTipoPagoCheque
  },
  data() {
    return {
      titulo: "Clientes",
      rutaApi: "Cliente/",
      itemVacio: {
        Id_Cliente: 0,
        Nombre: "",
        RazonSocial: "",
        Direccion: "",
        Cp: "",
        Id_Localidad: 0,
        Telefono: "",
        Celular: "",
        Email: "",
        FechaNacimiento: "",
        Id_TipoIva: "F",
        Cuit: "",
        Id_TipoIb: "G",
        Ib: "",
        Id_TipoIg: "E",
        Limite: 0,
        Id_TipoVenta: "I",
        Id_TipoPagoCheque: "X",
        Nota: "",
        AlicuotaPercepcionIb: ""
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido",
        maximo15: v => (v || "").length <= 15 || "Máximo 15 caracteres",
        maximo50: v => (v || "").length <= 50 || "Máximo 50 caracteres",
        maximo100: v => (v || "").length <= 100 || "Máximo 100 caracteres",
        maximo500: v => (v || "").length <= 500 || "Máximo 500 caracteres",
        email: v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return !v || pattern.test(v) || "E-mail no válido";
        }
      },
      grillaColumnas: [
        { text: "Nombre de Fantasía", value: "Nombre" },
        { text: "Razón Social", value: "RazonSocial" },
        { text: "CUIT", value: "Cuit" }
      ],
      grillaItems: [],
      grillaActivo: false,
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: ""
    };
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Nuevo":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoCuit");
          break;
        case "Guardar":
          if (this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "Abrir":
          this.grillaActivo = true;
          this.grillaItems = [];
          break;
        case "Editar":
          this.grillaActivo = false;
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoCuit");
          break;
        case "Borrar":
          this.grillaActivo = false;
          this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          break;
        case "AceptarConfirmacionBorrar":
          this.borrarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarConfirmacionBorrar":
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.itemActivo = Object.assign({}, this.itemVacio);
          eventBus.$emit("inicializarCuit");
          eventBus.$emit("inicializarSelectLocalidad");
          this.controlSoloLectura = true;
          this.$refs.form.resetValidation();
          break;
      }
    },
    sugerirRazonSocial() {
      if (this.itemActivo.RazonSocial == "")
        this.itemActivo.RazonSocial = this.itemActivo.Nombre;
    },
    guardarItem(item) {
      this.loading = true;
      HttpHelper.post(this.rutaApi, item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    borrarItem(item) {
      this.loading = true;
      HttpHelper.delete(this.rutaApi + item.Id_Cliente)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEjecutarAccion(accion, textoBuscado) {
      switch (accion) {
        case "Listar":
          this.grillaListarItems(textoBuscado);
          break;
        case "Cerrar":
          this.grillaActivo = false;
          break;
      }
    },
    grillaListarItems(textoBuscado) {
      this.loading = true;
      this.grillaItems = [];
      HttpHelper.get(this.rutaApi, {
        palabra: textoBuscado
      })
        .then(response => {
          this.grillaItems = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEditarItem(item) {
      this.loading = true;
      HttpHelper.get(this.rutaApi, {
        id: item.Id_Cliente
      })
        .then(response => {
          this.itemActivo = Object.assign({}, response.data);
          this.ejecutarAccion("Editar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaBorrarItem(item) {
      this.itemActivo = item;
      this.ejecutarAccion("Borrar");
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
